import axiosServer from '@/configs/axiosServer'
import axiosServerGolang from '@/configs/axiosServerGolang'

export default {
  async getReferences (Authorization) {
    try {
      const result = await axiosServer({
        method: 'GET',
        url: '/user/reference/',
        headers: { Authorization }
      })
      return result
    } catch (error) {
      return error
    }
  },
  async getInstitutionReferences (Authorization, payload) {
    try {
      const { page = 1, limit = 20, ...params } = payload
      const queries = new URLSearchParams(params).toString()
      const result = await axiosServer({
        method: 'GET',
        url: `/user/institution/${page}/${limit}?${queries}`,
        headers: {
          Authorization
        }
      })
      return result
    } catch (error) {
      return error
    }
  },
  async getYearLevelReferences (Authorization) {
    try {
      const result = await axiosServer({
        url: '/user/year/list',
        method: 'GET',
        headers: {
          Authorization: Authorization || process.env.VUE_APP_APP_KEY
        }
      })
      return result
    } catch (error) {
      return error
    }
  },
  async getRegionReferences (Authorization, payload) {
    try {
      const result = await axiosServerGolang({
        method: 'POST',
        url: '/user/complete-region',
        headers: {
          Authorization
        },
        data: payload
      })
      return result
    } catch (error) {
      return error
    }
  },
  async sendEmailOTP (Authorization) {
    try {
      const result = await axiosServer({
        method: 'POST',
        url: '/user/send-otp-email/',
        headers: {
          Authorization
        }
      })
      return result
    } catch (error) {
      return error
    }
  },
  async sendSkipEmailOTP (Authorization) {
    try {
      const result = await axiosServer({
        method: 'POST',
        url: '/user/send-skip-email-otp/',
        headers: {
          Authorization
        }
      })
      return result
    } catch (error) {
      return error
    }
  },
  async verifyEmailOTP (Authorization, payload) {
    try {
      const result = await axiosServer({
        url: `/user/verify-otp-email/?source=${window.btoa(this.pageSource)}`,
        method: 'POST',
        headers: {
          Authorization
        },
        data: payload
      })
      return result
    } catch (error) {
      return error
    }
  },
  async updateProfile (Authorization, data) {
    try {
      const result = await axiosServer({
        method: 'POST',
        url: '/user/manage/',
        headers: { Authorization },
        data
      })
      return result
    } catch (error) {
      return error
    }
  },
  async updatePhoneNumber (Authorization, data) {
    const url = 'user/update-phone-number'
    try {
      const result = await axiosServerGolang({
        method: 'POST',
        url,
        headers: {
          Authorization
        },
        data
      })
      return result
    } catch (error) {
      return error
    }
  },
  async getPreferenceContent (Authorization) {
    try {
      const result = await axiosServerGolang({
        method: 'GET',
        url: '/user/preference-content',
        headers: {
          Authorization
        }
      })
      return result
    } catch (error) {
      return error
    }
  },
  async updateUserPreference (Authorization, payload) {
    try {
      const result = await axiosServerGolang({
        method: 'POST',
        url: '/user/manage-profile',
        headers: {
          Authorization
        },
        data: payload
      })
      return result
    } catch (error) {
      return error
    }
  },
  async getAllDistrict (Authorization, payload) {
    try {
      const { page, limit = 20, ...params } = payload
      const queries = new URLSearchParams(params).toString()
      const result = await axiosServerGolang({
        method: 'GET',
        url: `/user/get-all-district/${page}/${limit}?${queries}`,
        headers: {
          Authorization
        }
      })
      return result
    } catch (error) {
      return error
    }
  },
  async getLearningObjective (Authorization) {
    try {
      const result = await axiosServerGolang({
        method: 'GET',
        url: '/user/learning-objective',
        headers: {
          Authorization
        }
      })
      return result
    } catch (error) {
      return error
    }
  }
}
